import React from 'react';
import { useTheme } from '../components/ThemeContext';
import { EarningsCalendarView } from '../components/earnings/EarningsCalendarView';
import { SEOMeta, getToolSEOMeta } from '../components/SEOMeta';

const Earnings: React.FC = () => {
  const { theme } = useTheme();
  const seoMeta = getToolSEOMeta('earnings');

  return (
    <div className={`min-h-screen ${theme === 'dark' ? 'bg-theme-primary' : 'bg-white'}`}>
      <SEOMeta
        title={seoMeta.title}
        description={seoMeta.description}
        keywords={seoMeta.keywords}
      />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <EarningsCalendarView />
      </div>
    </div>
  );
};

export default Earnings;
